export default "__VITE_ASSET__DxIO_qfa__"